import "../App.css";
import logo from "../imgs/Header.png";
import placeholder from "../imgs/placeholder.jpeg";

import Navbar from "../components/navbar"
import Warning from "../components/warning";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";

import { useInView } from "react-intersection-observer";
const FadeInTitle = ({ children }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <p ref={ref} className={`fade-in Sector Concert Center Cyan ${inView ? "visible" : ""}`}>
      {children}
    </p>
  );
};


const About = () => {
  return (
    <div className="App">
      <Helmet>
        <title>Heartland Fun: About Us</title>
        <meta name="title" content="Heartland Fun: About Us" />
        <meta name="description" content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta name="keywords" content="Arcade equipment, Claw machines, Gaming systems, Amusement supplier, Business entertainment, Arcade experience, Hassle-free purchasing, Entertainment solutions, Fun equipment, Gaming for businesses" />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta property="og:title" content="Heartland Fun: About Us" />
        <meta property="og:type" content="website" />
        <meta property="og:description " content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta property="og:determiner " content="" />
        <meta property="og:url" content="https://heartland.csfrederick.com/about" />
        <meta property="og:image" content="https://heartland.csfrederick.com/Header.png" />
        <meta property="og:image:secure_url" content="https://heartland.csfrederick.com/Header.png" />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>
      <Navbar></Navbar>
      <Warning></Warning>
      <FadeInTitle>
        ABOUT US
      </FadeInTitle>
      <br></br>
      <a href="tel:7858137921" className="Button Titillium Center">
        Connect with Our Experts
      </a>
      <div className="Brake"></div>
      <FadeInTitle>
        ARCADE MACHINES IN LAWRENCE, KS
      </FadeInTitle>
      <p className="Blue InfoText Titillium Center FadeIn">
        Looking for a reliable and affordable supplier for your amusement needs? Look no further than Heartland Fun! Our team is dedicated to providing you with top-notch service from the moment you place your order until it's delivered to your doorstep.
        <br></br><br></br>
        We pride ourselves on offering competitive prices and the latest technology in the industry. And if you're in Lawrence, KS, we invite you to come check us out in person. Don't miss out on the fun - contact Heartland Fun today!
      </p>
      <Footer></Footer>
    </div>
  );
};

export default About;